<template>
  <router-view />
</template>

<script>
export default {
  name: "Advance",
};
</script>

<style scoped></style>
